// extracted by mini-css-extract-plugin
module.exports = {"layout":"_2Q3l31oBv8_header-footer"};